import { SiteAddress } from 'types'
// ============================================================================
// NETSUITE ASSET TYPES
// ============================================================================

export enum NetSuiteAssetStatus {
  Active = 'Active',
  Pending = 'Pending',
  Expired = 'Expired',
  Canceled = 'Canceled',
}

export type NetSuiteAssetProduct = {
  id?: number
  description?: string
  programCodes?: string[]
  skuValue?: string
}

export type LicenseAdmin = {
  email?: string
  firstName?: string
  lastName?: string
}

export type NetSuiteAssetSite = {
  id: number
  admins: LicenseAdmin[]
  address: SiteAddress
  claims: string[]
  inactive: boolean
  isRostered: boolean
  hasUsers: boolean
  name: string
  nsCustomerId?: string
}

export type NetSuiteAsset = {
  adminEmail: string
  id: number
  isActive: boolean
  isInternal: boolean
  cancelledDate?: string
  contractLineNSId: number
  expirationDate: string
  lastUnassignedEmailSent: string
  managerNetSuiteCustomerId: number
  modifiedBy: string
  modifiedDate?: string
  nsId: number
  nsName: string
  originationDate: string
  payerNetSuiteCustomerId: number
  product: NetSuiteAssetProduct
  site?: NetSuiteAssetSite
  startDate: string
  status: NetSuiteAssetStatus
}

export type ContractLineDetails = {
  assignedAssets: NetSuiteAsset[]
  unassignedAssets: NetSuiteAsset[]
  products: NetSuiteAssetProduct[]
  contractLineId?: number
  managerNetSuiteCustomerId?: number
  startDate?: string
  expirationDate?: string
  adminEmail?: string | null
  setupAdminEmailUserId?: number
  managerNetSuiteCustomerName?: string
  managerNetSuiteCustomerNSId?: string
}

// ============================================================================
// BULK ASSIGN TYPES
// ============================================================================

export type BulkAssignFormattedResult = {
  LicenseId: string
  siteId: string
  siteName: string
  productDescription: string
  status: string
  isActive: string
  adminEmail: string
  startDate: string
  expirationDate: string
}

export type BulkAssignUploadResults = {
  data: NetSuiteAsset[]
  errors?: string[]
  error?: string
  success?: boolean
}

export type BulkAssignColumnConfig = {
  label: string
  key: keyof BulkAssignFormattedResult
  sortable?: boolean
}

// ============================================================================
// NETSUITE CUSTOMER TYPES
// ============================================================================

export type NetSuiteCustomer = {
  address?: {
    city?: string
    country?: string
    region?: string
  }

  companyName?: string
  createdBy?: string
  createdDate?: string
  districtName?: string
  id: number
  inactive?: boolean
  isIndividual?: boolean
  mdrpid?: string
  nsCustomerId?: string
  nsParentCustomerId?: string
  nsUltParentCustomerId?: string
  parentCustomerId?: number
  ultParentCustomerId?: number
}
